import { render, staticRenderFns } from "./modalUpdateMatchFromLiveblog.vue?vue&type=template&id=7568c555&scoped=true&"
import script from "./modalUpdateMatchFromLiveblog.vue?vue&type=script&lang=js&"
export * from "./modalUpdateMatchFromLiveblog.vue?vue&type=script&lang=js&"
import style0 from "./modalUpdateMatchFromLiveblog.vue?vue&type=style&index=0&id=7568c555&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7568c555",
  null
  
)

export default component.exports